import React from 'react';

const LoadingSpinner = ({ message = "Chargement...", fullScreen = false }) => {
    const containerClass = fullScreen
        ? "loading-container-fullscreen"
        : "loading-container";

    return (
        <div className={containerClass}>
            <div className="loading-spinner">
                <div className="spinner"></div>
                <p className="loading-message">{message}</p>
            </div>
        </div>
    );
};

export default LoadingSpinner;
